import { observer } from 'mobx-react';
import { FC, ReactElement, memo, useMemo } from 'react';
import { mealChoiceEditModalStore } from '../../store/mealChoiceEditModalStore';
import { defaultIntegrationTooltipOptions } from '~/constants/integrations';
import integrationsStore from '~/mobx/integrationStore';
import { localeStore } from '~/mobx/localesStore';
import { isDisabledByPos } from '~/utils/helpers';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import MultiLanguageInput from '~/view/components/Controls/MultiLanguageInput/MultiLanguageInput';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';
import Text from '~/view/components/Text/Text';

export const MealChoiceEditModalNameBlock: FC = memo(
  observer((): ReactElement => {
    const { comboMealEditItemChoiceName } = integrationsStore.posRestrictions || {};
    const _isDisabledByPos = useMemo((): boolean => isDisabledByPos(comboMealEditItemChoiceName), [comboMealEditItemChoiceName]);

    const tooltip = useMemo(() => {
      return _isDisabledByPos
        ? { ...defaultIntegrationTooltipOptions, position: TOOLTIP_POSITION.PORTAL, wrapperClassName: 'full-height' }
        : undefined;
    }, [_isDisabledByPos]);

    return (
      <div className="d-flex flex-column">
        <Text type="block-header" text="name" disabled={_isDisabledByPos} required />

        <IntegrationManager setting={comboMealEditItemChoiceName} wrapperClassName="mt-2">
          <MultiLanguageInput
            enText={mealChoiceEditModalStore.choiceName.en}
            arText={mealChoiceEditModalStore.choiceName.ar}
            validation={mealChoiceEditModalStore.validation}
            placeholder={localeStore.t('cmgc_name')}
            onChangeValue={mealChoiceEditModalStore.onChangeChoiceName}
            tooltip={tooltip}
            disabled={isDisabledByPos(comboMealEditItemChoiceName)}
            className="full-width"
          />
        </IntegrationManager>
      </div>
    );
  })
);
